module.exports = __webpack_public_path__ + "d67f01bf624059061cb3c6b308ad254b.png";